export const MailTempType = {
    SIGNATURE: 1,
    SEMI_FULL: 2,
    FULL: 3,
    JOB_TABLE: 4,
    DVTJCUV_INVITE_EMAIL: 5,
    DVTJCUV_EMAIL_FU: 6,
    DETAIL_WITH_CANDIDATE: 7,
    SEND_TC: 8,
}
